import type { IconData } from '@stacksjs/iconify-core'

export const googleDriveAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m6 19.796l3-5.197h12l-3 5.197z\"/><path fill=\"currentColor\" d=\"M15 14.599h6L15 4.204H9z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"m3 14.599l3 5.197L12 9.4L9 4.204L3 14.6z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default googleDriveAlt
